// extracted by mini-css-extract-plugin
export var overlay = "modal-module--overlay--tVA9x";
export var close = "modal-module--close--SIJd7";
export var videoModal = "modal-module--video-modal--zi8+T";
export var active = "modal-module--active--0API8";
export var open = "modal-module--open--2age1";
export var noCloseButton = "modal-module--no-close-button--EiE1q";